export const getIconButtonStyles = (
  colorType: 'primary' | 'secondary' | 'text',
  variant: 'text' | 'contained'
) => {
  if (variant === 'text') {
    switch (colorType) {
      case 'primary':
        return {
          width: '2.5rem',
          height: '2.5rem',
          padding: '0.125rem',
          '&:focus': {
            outline: 'none'
          },
          backgroundColor: 'transparent',
          color: 'var(--primary)',
          '&:hover': { color: 'var(--primary)' },
          '&:active': { color: 'var(--primary)' }
        }
      case 'secondary':
        return {
          width: '2.5rem',
          height: '2.5rem',
          padding: '0.125rem',
          '&:focus': {
            outline: 'none'
          },
          backgroundColor: 'transparent',
          color: 'var(--secondary)',
          '&:hover': { color: 'var(--secondary)' },
          '&:active': { color: 'var(--secondary)' }
        }
      default:
        return {
          width: '2.5rem',
          height: '2.5rem',
          padding: '0.125rem',
          '&:focus': {
            outline: 'none'
          },
          backgroundColor: 'transparent',
          color: 'var(--primary)',
          '&:hover': { color: 'var(--primary)' },
          '&:active': { color: 'var(--primary)' }
        }
    }
  }
  switch (colorType) {
    case 'primary':
      return {
        width: '2.5rem',
        height: '2.5rem',
        padding: '0.125rem',
        '&:focus': {
          outline: 'none'
        },
        backgroundColor: 'var(--transparentPrimary4)',
        color: 'var(--primary)',
        '&:hover': { backgroundColor: 'var(--transparentPrimary4)' },
        '&:active': { backgroundColor: 'var(--transparentPrimary4)' }
      }
    case 'secondary':
      return {
        width: '2.5rem',
        height: '2.5rem',
        padding: '0.125rem',
        '&:focus': {
          outline: 'none'
        },
        backgroundColor: 'var(--transparentSecondary4)',
        color: 'var(--secondary)',
        '&:hover': { backgroundColor: 'var(--transparentSecondary4)' },
        '&:active': { backgroundColor: 'var(--transparentSecondary4)' }
      }
    default:
      return {
        width: '2.5rem',
        height: '2.5rem',
        padding: '0.125rem',
        '&:focus': {
          outline: 'none'
        },
        backgroundColor: 'var(--transparentPrimary4)',
        color: 'var(--primary)',
        '&:hover': { backgroundColor: 'var(--transparentPrimary4)' },
        '&:active': { backgroundColor: 'var(--transparentPrimary4)' }
      }
  }
}
